module.exports = __webpack_public_path__ + "img/viscous_ooze_consume_item.c835f7b1.png";